import React from "react";

import img1 from "../img/Above all things&&First Operator Chronicles---Adobe Photoshop experiments with different patterns and textures over AI generated images___2025-11[[2]].jpg"

export default function Machine_2() {
  return (
    <div className="panel-block">
      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="2 · THE VAULT"
        />
      </div>

      <div className="panel-container-right">
        <h2>2 · The Vakzthari Vault</h2>

        <p>The Vault is where you can support <b>The Vakzthari Machine</b>,
            <br />
    where artifacts become accessible.
        </p>

        <p>
          Some are free.<br />
          Some require support.       
        </p>

        <p>
          Nothing here is permanent.<br />
          If something resonates, take it while it’s here.<br />
          The Vault sustains the Machine.
        </p>

        <p>
          Objects appear.<br />
          Hands reach.<br />
          Most arrive late.
        </p>

        <p>
          That is not failure.<br />
          That is the system working.
        </p>
      </div>
    </div>
  );
}
